<template>
  <fieldset class="mb-6">
    <heading class="mb-6 font-semibold" :level="2">{{ $t('Your payment details') }}</heading>
    <div class="flex flex-row justify-between mb-6">
      <div class="flex-1.5 mr-3">
        <div class="mb-2 font-semibold">
          <label for="card-number">{{ $t('Card number') }}</label>
        </div>
        <div>
          <div id="card-number"></div>
          <small v-if="errors.cardNumber" class="text-red">{{ errors.cardNumber }}</small>
        </div>
      </div>
      <div class="flex-auto mr-3">
        <div class="mb-2 font-semibold">
          <label for="card-expiry">{{ $t('Expires at') }}</label>
        </div>
        <div>
          <div id="card-expiry"></div>
          <small v-if="errors.cardExpiry" class="text-red">{{ errors.cardExpiry }}</small>
        </div>
      </div>
      <div class="flex-0.5">
        <div class="mb-2 font-semibold">
          <label for="card-cvc">{{ $t('CVC') }}</label>
        </div>
        <div>
          <div id="card-cvc"></div>
          <small v-if="errors.cardCvc" class="text-red">{{ errors.cardCvc }}</small>
        </div>
      </div>
    </div>
    <div>
      <div class="mb-2 font-semibold">
        <label for="name">{{ $t('Name on card') }}</label>
      </div>
      <div>
        <input
          id="name"
          :value="$attrs.value"
          name="name"
          type="text"
          autocomplete="name"
          class="form-control form-input form-input-bordered w-full"
          @input="$emit('input', $event.target.value)"
        >
      </div>
    </div>
  </fieldset>
</template>

<script>
  import * as stripeService from '@/_legacy/services/stripe';

  export default {
    name: 'StripeCard',

    data() {
      return {
        errors: {
          cardNumber: null,
          cardExpiry: null,
          cardCvc: null,
        },
      };
    },

    async mounted() {
      await stripeService.getStripe();
      await this.mountStripeElements();
      this.getStripeErrors();
    },

    methods: {
      async mountStripeElements() {
        await stripeService.cardNumber.value.mount('#card-number');
        await stripeService.cardExpiry.value.mount('#card-expiry');
        await stripeService.cardCvc.value.mount('#card-cvc');
      },

      getStripeErrors() {
        [stripeService.cardNumber.value, stripeService.cardExpiry.value, stripeService.cardCvc.value].forEach(element => {
          element.on('change', event => {
            this.errors[event.elementType] = event.error && event.error.message;
          });
        });
      },
    },
  };
</script>
